import React from 'react';
import { Box, Pagination } from '@mui/material';

const PaginationComponent = ({ count, page, onChange, pageSize = 12 }) => {
    const totalPages = Math.ceil(count / pageSize);

    if (totalPages <= 1) return null;

    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            mt: 4, 
            mb: 4,
            '& .MuiPaginationItem-root': {
                color: '#1a237e',
                fontWeight: 500,
            },
            '& .Mui-selected': {
                backgroundColor: '#1a237e !important',
                color: '#fff !important',
            }
        }}>
            <Pagination 
                count={totalPages} 
                page={page} 
                onChange={(event, value) => onChange(value)} 
                color="primary"
                shape="rounded"
                size="large"
            />
        </Box>
    );
};

export default PaginationComponent;
